import { loadStripe } from '@stripe/stripe-js'
import { SetStateAction } from 'react'
import get from 'lodash/get'
import { Dispatch } from 'react'
import {
  GetOrganizationQuery,
  Organization,
  OrganizationUsagePlan,
} from 'src/gql/graphql'

const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY

if (!STRIPE_PUBLISHABLE_KEY) {
  throw new Error('Stripe publishable key is not set')
}

export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY)

export const calculateWorkspaceCost = (
  memberCount: number,
  usagePlan: OrganizationUsagePlan,
) => {
  if (usagePlan === OrganizationUsagePlan.Explore) return 0
  if (usagePlan === OrganizationUsagePlan.Grow) return memberCount * 5 // $5 per member
  if (usagePlan === OrganizationUsagePlan.Scaleup)
    throw new Error(
      'The Scale-Up plan requires custom pricing. Please contact our sales team at partners@cognentai.com for more information.',
    )
}

export const getEffectivePlan = (
  planType: string | null,
  organizationPlan?: string,
): OrganizationUsagePlan => {
  const planHierarchy = {
    [OrganizationUsagePlan.Explore]: 0,
    [OrganizationUsagePlan.Grow]: 1,
    [OrganizationUsagePlan.Scaleup]: 2,
    [OrganizationUsagePlan.Super]: 3,
  }

  const currentPlan = organizationPlan || OrganizationUsagePlan.Explore
  const requestedPlan =
    (planType as OrganizationUsagePlan) || OrganizationUsagePlan.Explore

  // TODO: update this logic in the future if JM decides to change the price for Scale-Up plan
  if (requestedPlan === OrganizationUsagePlan.Scaleup) {
    return currentPlan as OrganizationUsagePlan
  }

  return planHierarchy[requestedPlan as OrganizationUsagePlan] >
    planHierarchy[currentPlan as OrganizationUsagePlan]
    ? (requestedPlan as OrganizationUsagePlan)
    : (currentPlan as OrganizationUsagePlan)
}

export const updateTokenAvailability = (
  data: GetOrganizationQuery['organization'],
  setTokenAvailable: Dispatch<SetStateAction<boolean>>,
) => {
  const reserveToken = get(data, 'subscriptionDetails.reserveTokens', 0)
  const isAvailable = reserveToken > 0
  setTokenAvailable(isAvailable)
}
